export default __webpack_public_path__ + "static/facebook-banner-size-e26971e1cc6384ea2e577f3fbc9a60e0.jpg";